// extracted by mini-css-extract-plugin
module.exports = {"metric":"styles_metric__IpAFB","title":"styles_title__5XtxZ","infoPopover":"styles_infoPopover__vtB90"};